export default {"src":"/_next/static/media/trustpilot-star-whole.2fc38df2.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};